import { Events } from '@/api/events';
import { User } from '@/api/user';
import { SendList } from '@/api/sendList';
import { Archive } from '@/api/archive';
import { Company } from '@/api/company';

const api = {
    user: new User('/user'),
    events: new Events('/event'),
    sendList: new SendList('/mailing'),
    archive: new Archive('/archive'),
    company: new Company('/company'),
};

export default api;
